import { IGetAvaliacoesByIdFornecedorUseCase } from "../../../presentation/useCases/read/get_avaliacoes_by_id_fornecedor_use_case";
import { FornecedorAvaliacao } from "../../models/fornecedor_avaliacao";
import { IComprasRepository } from "../../repositories/compras_repositories";

/**
 * GetAvaliacoesByIdFornecedorUseCase
 */

export class GetAvaliacoesByIdFornecedorUseCase implements IGetAvaliacoesByIdFornecedorUseCase {
  constructor(private readonly repository: IComprasRepository) { }

  async getAvaliacoesByIdFornecedor(
    idFornecedor: number | undefined,
  ): Promise<FornecedorAvaliacao[]> {
    if (idFornecedor === undefined) throw new Error('Falha ao obter id do fornecedor!');
    return await this.repository.getAvaliacoesByIdFornecedor(idFornecedor);
  }
}
